import NotificationActions from '../../../actions/NotificationActions';
import GuestActions from '../../../actions/GuestActions';
import UserStore from '../../../stores/UserStore';
import { endPoints as GuestEndPoints } from '../../../constants/GuestConstants';
import { endPoints as UserEndPoints } from '../../../constants/UserConstants';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';
import AjaxPromises from '../../../utils/AjaxPromises';

export default class AdjustLoyaltyPoints extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading     : false,
            visible     : false,
            pin    : '',
            loyalty     : 0,
            adjustLoyaltyReason: '',
            reasons             : [],
        };

        this.adjust = this.adjust.bind(this);
        this.open = this.open.bind(this);
        this.isValid = this.isValid.bind(this);
        this.canAdjust = this.canAdjust.bind(this);
        this.checkManagerPin = this.checkManagerPin.bind(this);
        this.requireManagerPin = this.requireManagerPin.bind(this);
        this.makeAdjustment = this.makeAdjustment.bind(this);
    }

    componentDidMount() {
        this.loadAdjustLoyaltyReasons();
    }

    loadAdjustLoyaltyReasons() {
        var self = this;

        AjaxPromises.POST(PosEndPoints.LOAD_ADJUST_lOYALTY_REASONS, UserStore.getApiData()).then(res => {
            self.setState({
                reasons : res.Data || [],
            });
        });
    }

    open() {
        if (!this.canAdjust()) {
            return false;
        }

        this.setState({ visible : true });
    }

    isValid() {
        var guest = this.props.guest;

        if (this.requireManagerPin() && this.state.pin.length < 1) {
            return false;
        }

        if (UserStore.getState().selectedLocation.RequireAdjustLoyaltyReason && !this.state.adjustLoyaltyReason) {
            return false;
        }

        if (guest.LoyaltyPoints == this.state.loyalty) {
            return false;
        }

        return true;
    }

    canAdjust() {
        var guest = this.props.guest;

        if (!!guest.MJStateIDNo && 
            guest.MJStateIDNo.length > 1 &&
            guest.MJStateIDNo[0].toLowerCase() === 'c' && 
            guest.MJStateIDNo[1].toLowerCase() === 'g' &&
            !UserStore.getState().selectedLocation.AllowAdjustCaregiverLoyaltyPoints) {
            return false;
        }

        return true;
    }

    makeAdjustment() {

        if(!this.isValid()){
            return;
        }

        if(this.requireManagerPin()) {
            this.checkManagerPin();
        } else {
            this.adjust();
        }
    }

    checkManagerPin() {
        var self = this;
        if (this.state.pin.length < 1) {
            NotificationActions.addNotification({ type : 'alert', body : 'Manager PIN Missing' });
            return;
        }

        AjaxPromises.POST(UserEndPoints.CHECK_PIN_NUMBER, UserStore.getApiData({
            ShipmentId : this.props.guest.ShipmentId,
            PinCode : this.state.pin,
        })).then(res => {
            if (res.Data[0].MgrPermission === true) {
                self.adjust(res.Data[0].UserId);
            } else {
                NotificationActions.addNotification({ type : 'alert', body : 'Invalid PIN' });
            }
        });
    }

    requireManagerPin() {
        return UserStore.getState().selectedLocation.ManagerPasswordForLoyaltyAdjustments;
    }

    adjust(PinUserId = null) {
        var guest = this.props.guest;

        if (this.state.loyalty.length < 1)
            return;

        if (parseFloat(this.state.loyalty).toFixed(2) < 0)
            return;

        var diff = parseFloat(this.state.loyalty).toFixed(2) - parseFloat(guest.LoyaltyPoints).toFixed(2);

        AjaxPromises.POST(GuestEndPoints.ADJUST_LOYALTY_POINTS, UserStore.getApiData({
            TransactionBy : UserStore.getState().user.userId,
            GuestId : guest.Guest_id,
            TransactionAmt : diff,
            AdjustLoyaltyReason: this.state.adjustLoyaltyReason,
            PinUserId,
        })).then(res => {

            NotificationActions.addNotification({
                type : res.Result ? 'success' : 'error',
                body : res.Result ? 'Loyalty adjusted' : 'Failed to adjust loyalty points'
            });

            if (res.Result) {
                this.setState({
                    loading : false,
                    visible : false,
                    pin : '',
                    loyalty : 0
                });

                GuestActions.loadFullGuest(guest.Guest_id);
            }
            else
                this.setState({
                    loading : false
                });
        });
    }

    onChange(e) {
        this.setState({ loyalty : e.target.value.replace(/[^.0-9]/g, '') });
    }

    render() {
        var self = this;

        var guest = this.props.guest;

        var adjust = this.canAdjust() ? '(Adjust)' : '';
        var valid = this.isValid();

        return (

            <div className='col-6'>
                <div
                    onClick={this.open}
                    style={{'cursor':'pointer'}}>

                    {guest.LoyaltyPoints} {adjust}
                </div>

                { this.state.visible &&
                    <div className='popup popup__transparent'>
                        <div className='popup__content adjust-loyalty'>

                            <div className='popup-header'>
                                ADJUST LOYALTY POINTS

                                <div
                                    className='popup-close'
                                    onClick={() => { this.setState({ visible : false, pin : '', loyalty : 0 }); }}>

                                    <i className='fa fa-times' aria-hidden='true' />
                                </div>
                            </div>

                            <div className='adjust-loyalty__content container'>
                                <div className='row' style={{'height':'54px'}}>
                                    <div className='col-7'>
                                        Current Amount
                                    </div>
                                    <div className='col-5'>
                                        {guest.LoyaltyPoints}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-7'>
                                        Adjust to
                                    </div>
                                    <div className='col-5'>
                                        <input
                                            type='text'
                                            value={this.state.loyalty}
                                            className='input-text-1'
                                            onChange={self.onChange.bind(self)} />
                                    </div>
                                </div>

                    {UserStore.getState().selectedLocation.RequireAdjustLoyaltyReason &&
                    <div>
                        <div className='return-form__question'>
                            Adjust Loyalty Reason
                        </div>
                        <div className='return-form__answer'>
                            {this.state.reasons.length === 0 ? (
                                <textarea
                                    className='return-form__reason'
                                    value={this.state.adjustLoyaltyReason}
                                    placeholder='Reason for adjusting loyalty...'
                                    onChange={(e) => { this.setState({ adjustLoyaltyReason : e.target.value });}}>

                                </textarea>
                            ) : (
                                <select
                                    className='form-control' 
                                    value={this.state.adjustLoyaltyReason}
                                    onChange={(e) => { this.setState({ adjustLoyaltyReason : e.target.value });}}>

                                    <option disabled value=''>
                                        Select Reason
                                    </option>

                                    { this.state.reasons.map(r => {
                                        return (
                                            <option
                                                key={r.AdjustLoyaltyReasonId}
                                                value={r.Reason}>

                                                {r.Reason}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                        </div>
                    </div>
                    }
                        { this.requireManagerPin() && 
                            <div className='row'>
                                <div className='col-7'>
                                    Manager PIN
                                </div>
                                <div className='col-5'>
                                    <input
                                        type='password'
                                        value={this.state.pin}
                                        className='input-text-1'
                                        onChange={(e) => { this.setState({ pin : e.target.value }); }} />
                                </div>
                            </div>
                            }

                            <div className='row'>
                                <div className='col-9'>

                                </div>
                                <div className='col-3'>
                                    <div
                                        className={'adjust-loyalty__ok btn-green '+(!valid ? 'btn-green__disabled' : '')}
                                        onClick={this.makeAdjustment}>

                                        Adjust
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                }

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/AdjustLoyaltyPoints.react.jsx